"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieceCount = PieceCount;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const context_1 = require("~/auth/context");
const useBoard_1 = require("~/components/board/useBoard");
const sessionContext_1 = require("~/game/sessionContext");
const players_1 = require("~/store/game/players");
const models_1 = require("@creature-chess/models");
const useStyles = (0, react_jss_1.createUseStyles)({
    pieceCount: {
        "fontSize": "14px",
        "fontStyle": "italic",
        "textAlign": "center",
        "width": "fit-content",
        "fontWeight": "700",
        "padding": "8px",
        "letterSpacing": "2px",
        "color": "#fff",
        "background": "#1d1d1d",
        "border": "2px solid #121212",
        "@media (orientation: portrait) and (max-width: 400px)": {
            fontSize: "10px",
            padding: "4px",
            letterSpacing: "1px",
        },
    },
    pieceCountWarning: {
        color: "#ff6464",
        background: "#ffd2d2",
        border: "2px solid #ff6464",
    },
});
function PieceCount() {
    var _a, _b;
    const styles = useStyles();
    const { board, pieceRegistry } = (0, sessionContext_1.useGameSession)();
    const b = (0, useBoard_1.useBoardSubscription)(board);
    const playerId = (0, context_1.useAccountId)();
    const pieceCount = b
        .getAllPieces()
        .filter((p) => { var _a; return ((_a = pieceRegistry.getPieceById(p.id)) === null || _a === void 0 ? void 0 : _a.ownerId) === playerId; }).length;
    const level = (_b = (_a = (0, players_1.useLocalPlayer)()) === null || _a === void 0 ? void 0 : _a.level) !== null && _b !== void 0 ? _b : 0;
    const inPreparingPhase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase === models_1.GamePhase.PREPARING);
    if (!inPreparingPhase) {
        return null;
    }
    if (pieceCount < level) {
        return (react_1.default.createElement("p", { className: (0, classnames_1.default)(styles.pieceCount, styles.pieceCountWarning) },
            pieceCount,
            " / ",
            level,
            " pieces"));
    }
    return (react_1.default.createElement("p", { className: styles.pieceCount },
        pieceCount,
        " / ",
        level,
        " pieces"));
}
